var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    width: "2rem",
    height: "2rem",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0Shopp{fill-rule:evenodd;clip-rule:evenodd;fill:#EE4D30;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path2-2",
    className: "st0Shopp",
    d: "M98.54,111.02c-0.84,6.96-5.06,12.54-11.6,15.33c-3.64,1.56-8.53,2.4-12.4,2.13 c-6.03-0.23-11.7-1.7-16.93-4.38c-1.87-0.96-4.65-2.87-6.79-4.67c-0.54-0.45-0.61-0.74-0.25-1.25c0.19-0.29,0.55-0.82,1.34-1.97 c1.14-1.67,1.29-1.88,1.41-2.08c0.37-0.56,0.96-0.61,1.55-0.15c0.06,0.05,0.06,0.05,0.11,0.08c0.1,0.07,0.1,0.07,0.32,0.25 c0.23,0.18,0.37,0.28,0.42,0.33c5.64,4.41,12.2,6.96,18.83,7.21c9.22-0.13,15.85-4.27,17.04-10.64 c1.31-7.01-4.19-13.06-14.95-16.43c-3.36-1.05-11.87-4.46-13.44-5.38c-7.36-4.32-10.81-9.98-10.32-16.97 c0.75-9.69,9.75-16.92,21.11-16.97c5.08-0.01,10.16,1.05,15.03,3.1c1.73,0.73,4.81,2.4,5.87,3.2c0.61,0.45,0.73,0.97,0.38,1.54 c-0.2,0.33-0.52,0.85-1.2,1.93l-0.01,0.01c-0.9,1.43-0.93,1.47-1.13,1.81c-0.36,0.54-0.78,0.59-1.42,0.19 c-5.21-3.5-11-5.27-17.35-5.39c-7.91,0.16-13.85,4.87-14.24,11.28c-0.1,5.8,4.24,10.03,13.63,13.25 C92.62,92.52,99.91,99.7,98.54,111.02 M75,10.97c12.41,0,22.52,11.78,23,26.52H52.01C52.48,22.74,62.59,10.97,75,10.97  M139.22,40.25c0-1.53-1.23-2.77-2.75-2.77h-29.81C105.93,18.02,92.03,2.5,75,2.5c-17.03,0-30.92,15.52-31.65,34.98l-29.85,0 c-1.5,0.03-2.7,1.26-2.7,2.77c0,0.07,0,0.14,0.01,0.21h-0.02l4.26,93.81c0,0.26,0.01,0.52,0.03,0.79c0,0.06,0.01,0.12,0.01,0.18 l0.01,0.2l0.01,0.01c0.65,6.53,5.38,11.79,11.83,12.03l0.01,0.01h94.7c0.04,0,0.09,0,0.13,0c0.04,0,0.09,0,0.13,0h0.2l0,0 c6.55-0.18,11.86-5.51,12.42-12.12l0,0l0-0.09c0.01-0.07,0.01-0.14,0.01-0.21c0.01-0.17,0.02-0.33,0.02-0.5l4.64-94.18h0 C139.22,40.35,139.22,40.3,139.22,40.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopee);
export default __webpack_public_path__ + "static/media/shopee.0f0a36c360378303313cfec5fd4ea9e7.svg";
export { ForwardRef as ReactComponent };